export function getApiErrorMessage(error, fallback = 'Request failed') {
    if (!error) return fallback
    const data = error.response?.data
    if (typeof data === 'string') return data
    if (data?.message) return data.message
    if (data) return JSON.stringify(data)
    return error.message || fallback
}
